import { render } from "./UiEditor.vue?vue&type=template&id=0797599b"
import script from "./UiEditor.vue?vue&type=script&lang=js"
export * from "./UiEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__